import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import React from "react";
import { notifySomething } from "../_Utils/AppDocuCommon";
import CalibrationDialogForm from "./_CalibrationDialogForm";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";

export default class AddCalibrationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddCalibrationDialog.getInitialItemData(),
    };
    this.fileInputRef = React.createRef();
  }

  static getInitialItemData() {
    return {
      file: null, // This will be set when a file is selected
      name: '',
      ecu_type: '',
      injector: '',
      fw_version: '',
      sw_version: '',
      usage_info: '',
      status: '',
      com_brand: '',
    };
  }

  addCalibrationService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.createCalibration(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding calibration', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the calibrations list after adding !!!
      this.props.onClose(); // Close the dialog after adding !!!
    } catch (error) {
      console.error('Error adding calibration:', error);
      notifySomething('Error adding calibration', 'error');
    }
  };
    
  handleAdd = async () => {
    const m = this.state.itemData || {};
    const formData = new FormData();
    if (m.file) formData.append('file', m.file);
    formData.append('name', m.name || '');
    formData.append('ecu_type', m.ecu_type || '');
    formData.append('injector', m.injector || '');
    formData.append('fw_version', m.fw_version || '');
    formData.append('sw_version', m.sw_version || '');
    formData.append('usage_info', m.usage_info || '');
    formData.append('status', m.status || '');
    formData.append('com_brand', m.com_brand || '');
    // Call the service to add the calibration
    await this.addCalibrationService(formData);
  };

  componentDidUpdate(prevProps) {
    // Reset fields when dialog is opened
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddCalibrationDialog.getInitialItemData() });
    }
  }

  render() {
    const handleFileChange = (e) => {
      const file = e.target.files && e.target.files[0];
      if (file) {
        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
        this.setState({ itemData: { ...this.state.itemData, file, name: nameWithoutExt } });
      }
    };
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) {
        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
        this.setState({ itemData: { ...this.state.itemData, file, name: nameWithoutExt } });
      }
    };
    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const handleClickDropArea = () => {
      if (this.fileInputRef.current) this.fileInputRef.current.click();
    };
    return (
      <Dialog open={!!this.props.isOpen} onClose={this.props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Calibration</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
          <Stack spacing={2}>
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onClick={handleClickDropArea}
              style={{
                border: '2px dashed #1976d2',
                borderRadius: 8,
                padding: 20,
                textAlign: 'center',
                color: '#1976d2',
                background: '#f5faff',
                cursor: 'pointer',
                marginBottom: 8
              }}
            >
              Trascina qui il file da caricare oppure clicca per selezionarlo
              <input
                type="file"
                ref={this.fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              {this.state.itemData.file && (
                <div style={{ marginTop: 8, color: '#333' }}>
                  File selezionato: {this.state.itemData.file.name}
                </div>
              )}
            </div>
            <CalibrationDialogForm
              itemData={this.state.itemData}
              onChange={newData => this.setState({ itemData: newData })}
              hideOriginalFilename={true}
              disabled={false}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.handleAdd} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
